import { StatisticsController } from 'api/controllers/StatisticsController';
import { useQuery } from 'react-query';
import { PreviousVotingStatisticsResponse } from 'api/controllers/typings';
import { BasicQueryOptions } from '../typings';
import { GET_PREVIOUS_VOTING_STATISTICS } from '../queryKeys';

export const useGetPreviousVotingStatistics = ({
  onSuccess,
  onError,
}: BasicQueryOptions<PreviousVotingStatisticsResponse> = {}) =>
  useQuery({
    queryKey: [GET_PREVIOUS_VOTING_STATISTICS],
    queryFn: () => StatisticsController.getPreviousVotingStatistics(),
    onSuccess,
    onError,
  });
